<!-- ============================================================== -->
<!-- sidebar -->
<!-- ============================================================== -->

<aside class="clickup-sidebar" [class.clickup-sidebar--compact]="compact" aria-label="Navegación principal">
  <div class="clickup-sidebar__header">
    <div class="workspace-switcher" [attr.aria-label]="brandName">
      <span>{{ brandName }}</span>
    </div>
    <button
      *ngIf="showCompactToggle"
      mat-icon-button
      class="clickup-sidebar__toggle"
      type="button"
      (click)="toggleCompact()"
      [matTooltip]="compact ? 'Expandir menú' : 'Contraer menú'"
      [attr.aria-label]="compact ? 'Expandir menú' : 'Contraer menú'"
    >
      <mat-icon>{{ compact ? 'menu_open' : 'menu' }}</mat-icon>
    </button>
  </div>

  <mat-nav-list appAccordion class="clickup-sidebar__nav">
    <mat-list-item appAccordionLink *ngFor="let menuitem of menuItems.getMenuitem()" routerLinkActive="selected">
      <a
        appAccordionToggle
        [routerLink]="['/', menuitem.state]"
        (click)="navigationSelected.emit()"
        *ngIf="menuitem.type === 'link'"
        [matTooltip]="compact ? menuitem.name : ''"
        matTooltipPosition="right"
      >
        <mat-icon>{{ menuitem.icon }}</mat-icon>
        <span>{{ menuitem.name }}</span>
        <span fxFlex></span>
      </a>
    </mat-list-item>
  </mat-nav-list>
</aside>
